import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Button,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";

interface HistoricoAvaluo {
  id: string;
  idClaveCatastral: string;
  idMotivoAvaluo: number;
  areaTerreno: number;
  valorTerreno: number;
  obsAvaluo: string;
  fechaAvaluo: string;
  valuador: string;
  fechaActualizacion: string;
  añoAvaluo: number;
  idTramite: string;
  fechaOperacion: string;
  usuario: string;
  idNaturalezaActo: number;
  valorComercial: number;
  cajaPagoPredial: string;
  folioPagoPredial: number;
  cajaPagoAvaluo: string;
  folioPagoAvaluo: number;
  tipoDocumento: string;
  idAvaluo: string;
  idAvaluoMunicipio: string;
  rutaArchivoPdf: string;
}

const HistoricoAvaluo: React.FC<{ idClaveCatastral: number }> = ({
  idClaveCatastral,
}) => {
  const [historico, setHistorico] = useState<HistoricoAvaluo[]>([]);
  const toast = useToast();

  // Obtener datos del histórico
  useEffect(() => {
    const fetchHistorico = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/historicoAvaluoRoutes/${idClaveCatastral}`
        );

        // Transformar datos para asegurar que los valores sean correctos
        const sanitizedData = response.data.map((item: any) => ({
          ...item,
          areaTerreno: parseFloat(item.areaTerreno) || 0,
          valorTerreno: parseFloat(item.valorTerreno) || 0,
          valorComercial: parseFloat(item.valorComercial) || 0,
          folioPagoPredial: parseInt(item.folioPagoPredial, 10) || 0,
          folioPagoAvaluo: parseInt(item.folioPagoAvaluo, 10) || 0,
        }));

        setHistorico(sanitizedData);
      } catch {
        toast({
          title: "Error",
          description: "No se pudo cargar el historial de avalúos.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };

    fetchHistorico();
  }, [idClaveCatastral, toast]);

  return (
    <Box p={4}>
      <Table variant="simple" mt={6}>
        <Thead>
          <Tr>
            <Th>ID Avalúo</Th>
            <Th>Área Terreno</Th>
            <Th>Valor Terreno</Th>
            <Th>Fecha Avalúo</Th>
            <Th>Valuador</Th>
            <Th>Valor Comercial</Th>
            <Th>Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {historico.map((item) => (
            <Tr key={item.id}>
              <Td>{item.idAvaluo}</Td>
              <Td>{item.areaTerreno.toFixed(2)} m²</Td>
              <Td>${item.valorTerreno.toFixed(2)}</Td>
              <Td>{new Date(item.fechaAvaluo).toLocaleDateString()}</Td>
              <Td>{item.valuador}</Td>
              <Td>${item.valorComercial.toFixed(2)}</Td>
              <Td>
                <Button
                  size="sm"
                  colorScheme="blue"
                  onClick={() => {
                    window.open(item.rutaArchivoPdf, "_blank");
                  }}
                >
                  Ver PDF
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default HistoricoAvaluo;
